<div class="bb-dimension">
	<input [placeholder]="placeholder" [style.width]="inputWidth" class="join-right" [(ngModel)]="dimension" type="text"
		(ngModelChange)="onValueChange($event)" (keydown)="onKeydown($event)" />
	<bb-select *ngIf="units && units.length > 1" [(ngModel)]="dimensionUnit" (ngModelChange)="onDimensionUnitChange()"
		[options]="units"></bb-select>
	<div class="join-left no-select" *ngIf="units && units.length === 1">{{ units[0].label }}</div>
</div>
